<template>
  <div>
    <v-card elevation="5" class="p-1">
      <div v-if="!loading" class="p-3">
        <span class="text-xl mb-2">
          Planilha contas a receber da empresa:
          {{ empresa.id + " - " + empresa.razao_social }}</span
        >
      </div>

      <div class="w-full">
        <b-table
          :data="contas_receber"
          :columns="columns"
          hoverables
          paginated
          style="font-size: 13px"
          narrowed
          :loading="loading"
          default-sort-direction="asc"
          default-sort="id"
          backend-pagination
          @page-change="onPageChange"
          aria-next-label="Next page"
          aria-previous-label="Previous page"
          aria-page-label="Page"
          aria-current-label="Current page"
          :total="pagination.total"
          :current-page="pagination.current_page"
          :per-page="pagination.per_page"
          striped
        >
          <template slot-scope="props">
            <b-table-column style="width: 130px" field="valor" sortable>
              <span
              v-if="props.row.fatura"
                class="bg-success-base text-neutral-100 p-1 mt-1 rounded"
                :class="{
                  'bg-success-base': props.row.fatura.status === 'pago',
                  'bg-warning-base': props.row.fatura.status === 'pendente',
                  'bg-error-base':
                    props.row.fatura.status === 'cancelado' ||
                    props.row.fatura.status === 'atrasado',
                }"
              >
                {{ props.row.fatura.subtotal }}
              </span>
              <span v-else class="bg-success-base text-neutral-100 p-1 mt-1 rounded bg-warning-base" >
                {{ props.row.valor}}
              </span>
            </b-table-column>

            <b-table-column style="width: 150px" field="vencimento">
              <Lynx-Input type="date" v-model="props.row.vencimento" />
            </b-table-column>

            <b-table-column style="width: 250px" field="descricao">
              {{ props.row.descricao }}
            </b-table-column>
            <b-table-column field="Status">
              <div v-if="props.row.fatura">
                <b-select
                  v-if="props.row.fatura.status != 'pago'"
                  v-model="props.row.fatura.status"
                  placeholder="selecione uma taxa"
                >
                  <option
                    v-for="status in StatusOptions"
                    :key="status.id"
                    :value="status.value"
                    v-text="status.label"
                  ></option>
                </b-select>
                <span
                  style="font-size: 13px"
                  class="bg-success-base text-neutral-100 p-1 mt-1 rounded"
                >
                  Pago
                </span>
              </div>
              <span
                v-else
                style="font-size: 13px"
                class="bg-warning-base text-neutral-100 p-1 mt-1 rounded"
              >
                Fatura não gerada
              </span>
            </b-table-column>
            <b-table-column style="width: 150px" field="updated_at">
              {{ formatEnToBr(props.row.updated_at) }}
            </b-table-column>

            <b-table-column field="acoes" sortable searchable>
              <!-- <Lynx-Button
                class="self-start mt-2"
                icon="Save"
                icon-size="3"
                size="small"
                @click.native="editContaReceber(props.row)"
              />

              <Lynx-Button
                v-if="hasRole('super-admin')"
                icon="User"
                color="success-base"
                icon-size="3"
                size="small"
                @click.native="openModelLogs(props.row)"
              /> -->
            </b-table-column>
          </template>
          <template v-if="!loading" v-slot:empty>
            <NotFoundData text="Nenhum parcelamento encontrado!" />
          </template>
        </b-table>
      </div>
    </v-card>

    <Logs
      v-if="modelLogs"
      :logs="logs"
      :model="modelLogs"
      @update:model="hide()"
    ></Logs>
  </div>
</template>

<script>
// import EditTaxa from "@/views/empresas/taxasAlvaras/Edit";
// import CreateTaxa from "@/views/empresas/taxasAlvaras/Create";
import NotFoundData from "@/components/layouts/NotFoundData";
import moment from "moment";
import { monthNames, dayNames } from "@/utils/utils";
import Treeselect from "@riophae/vue-treeselect";
import Alvaras from "@/views/empresas/show/Alvaras";
import { mapGetters } from "vuex";
import Logs from "@/views/empresas/alvaras/Logs";
import { hasRole } from "@/utils/can";
import InputMoney from "@/components/helpers/InputMoney";
import { StatusFaturasEnum } from "@/utils/enums/statusFatura";
export default {
  name: "ContasReceberIndex",
  props: {
    empresa: {
      default: null,
    },
  },
  components: {
    NotFoundData,
    Treeselect,
    Logs,
    InputMoney,
  },
  data() {
    return {
      filtros: {
        empresa_id: null,
        page: 1,
        perPage: 10,
      },
      StatusOptions: StatusFaturasEnum,
      columns: [
        {
          field: "valor",
          label: "Valor",
          sortable: true,
        },
        {
          field: "vencimento",
          label: "Data vencimento",
          sortable: true,
        },

        {
          field: "descricao",
          label: "Descrição",
          sortable: true,
        },
        {
          field: "status",
          label: "Status",
          sortable: true,
        },

        {
          field: "updated_at",
          label: "Ultima Atualização",
          sortable: true,
        },
        {
          field: "acoes",
          label: "Açoes",
        },
      ],
      logs: {},
      taxasEmpresa: {
        pagination: {
          current_page: 1,
          total_pages: 1,
          per_page: 10,
          total: 1,
        },
        data: [],
      },
      perPageOptions: [10, 50, 100],
      current_page: 1,
      loading: false,
      modelLogs: false,
    };
  },
  filters: {
    money: (value) => {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
  },

  computed: {
    ...mapGetters(["getToken"]),

    lista_contas_receber() {
      return this.$store.state.contasReceber.lista_contas_receber;
    },
    contas_receber() {
      return this.lista_contas_receber.data;
    },
    pagination() {
      return this.lista_contas_receber.pagination;
    },
    mensagem_alert() {
      return this.$store.state.contasReceber.mensagem_alert;
    },
  },
  watch: {
    "filtros.perPage"() {
      this.fetchContasReceber();
    },
    current_page() {
      this.filtros.page = this.current_page;
      this.fetchContasReceber();
    },
    empresa() {
      this.fetchContasReceber();
    },
  },
  created() {
    this.inicial();
  },
  methods: {
    hasRole,
    async inicial() {
      await this.fetchContasReceber();
    },
    getStatusClass(status) {
      return status === "pago"
        ? "bg-error-base text-neutral-100 pl-1 mt-1 rounded"
        : status === "pendente"
        ? "bg-warning-base text-neutral-100 pl-1 mt-1 rounded"
        : status === "cancelado"
        ? "bg-success-base text-neutral-100 pl-1 mt-1 rounded"
        : "bg-primary-600 text-neutral-100 pl-1 mt-1 rounded";
    },

    async fetchContasReceber() {
      this.loading = true;
      console.log(this.empresa);
      this.filtros.empresa_id = this.empresa.id;
      const { filtros } = this;
      await this.$store
        .dispatch("contasReceber/listar_contas_receber", filtros)
        .finally(() => (this.loading = false));
    },
    openCreateModal() {},
    openEditModal(contaReceber) {},
    onEditTaxa() {
      this.fetchContasReceber();
      this.editModal = false;
    },
    onCreateTaxa() {
      this.fetchContasReceber();
      this.createModal = false;
    },

    onPageChange(page) {
      this.current_page = page;
    },

    gerarRelatorio() {},
    editarTaxa(empresa_id) {},
    openModelLogs(value) {
      this.modelLogs = true;
      this.logs = value.logs;
    },

    async editContaReceber(taxa) {
      this.loading = true;

      await this.$store
        .dispatch("contasReceber/update_contas_receber", taxa)
        .then(() => {
          if (this.mensagem_alert.tipo == "success") {
            this.$snack.success(this.mensagem_alert.message);
          } else {
            this.$snack.error(this.mensagem_alert.message);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    formatEnToBr(date) {
      const momentDate = moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");

      if (momentDate != "Invalid date") {
        return momentDate;
      } else {
        return "sem data";
      }
    },
  },
};
</script>


